import {
	DEVICE_DESKTOP,
	DEVICE_TABLET_PORTRAIT,
	DEVICE_TABLET_LANDSCAPE,
	DEVICE_MOBILE_PORTRAIT,
	DEVICE_MOBILE_LANDSCAPE,
} from '../../../constants/types';

export function caseFilterResponsive(cases, browser) {
	let filteredCases = [];
	let matchViews = [];

	// Desktop return all
	if (browser.window.width >= 1200) {
		return cases;
	} else if (browser.window.width >= 720 && browser.window.width < 1200) {
		matchViews.push(DEVICE_TABLET_PORTRAIT, DEVICE_TABLET_LANDSCAPE);
	} else if (browser.window.width < 720) {
		matchViews.push(DEVICE_MOBILE_PORTRAIT, DEVICE_MOBILE_LANDSCAPE);
	}

	for (let i = 0; i < cases.length; i++) {
		if (matchViews.indexOf(cases[i].bestViewedOn) !== -1) {
			filteredCases.push(cases[i]);
		}
	}

	return filteredCases;
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/juryHelper.js
 **/